/**
 * FieldRow — `.field-row` from the prototype (cms-redesign-mockup.html
 * line 2962). A grid wrapper for multiple FieldBlocks on one line.
 *
 *   <FieldRow cols={2}>
 *     <FieldBlock label="Title"><TextInput .../></FieldBlock>
 *     <FieldBlock label="Author"><AuthorSelect .../></FieldBlock>
 *   </FieldRow>
 *
 *   <FieldRow cols={3}>
 *     <FieldBlock label="Title"><TextInput .../></FieldBlock>
 *     <FieldBlock label="Parent"><ParentSelect .../></FieldBlock>
 *     <FieldBlock label="Author"><AuthorSelect .../></FieldBlock>
 *   </FieldRow>
 *
 * Collapses to a single column on narrow viewports (≤640px) per the
 * prototype's mobile breakpoint (line 2503).
 */
import React from 'react';
import { cn } from '../cn';

export default function FieldRow({
  // Explicit column count. Each cell carries `min-width: 0` so a
  // child with a wide value (e.g. a long select label) doesn't
  // expand the column past its 1fr share. For mobile-first wrapping
  // pass `cols={1}` or rely on the surrounding edit-canvas to set
  // the overall max-width.
  cols = 2,
  gap = 14,
  className,
  children,
}) {
  return (
    <div
      className={cn(className)}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gap,
      }}
    >
      {children}
    </div>
  );
}
